<template>
    <div class="main-container">
        <component v-if="specialStep"
            :is="currentStepComponent" 
        ></component>
        <div v-else class="main_wrapper">
            <section class="main-section_header">
                <p class="main-header_title">{{ headerTitle }}</p>
                <p class="main-header_text">{{ headerSubtitle }}</p> 
            </section>
            <section class="main-section_body">
                <component 
                    :is="currentStepComponent" 
                    @update-title="updateHeaderTitle"
                    @update-subtitle="updateHeaderSubtitle"
                ></component>
                <div class="main-image"></div>
            </section>
        </div>
    </div>
</template>

<script>
// Steps
import step_productos from '../components/new_steps/step_productos.vue';
import step_datos_vivienda from '../components/new_steps/step_datos_vivienda.vue';
import step_datos_hipoteca_habitual from '../components/new_steps/step_datos_hipoteca_habitual.vue';
import step_datos_hipoteca_mejora from '../components/new_steps/step_datos_hipoteca_mejora.vue';
import step_datos_hipoteca_2avivienda from '../components/new_steps/step_datos_hipoteca_2avivienda.vue';
import step_datos_hipoteca_inversion from '../components/new_steps/step_datos_hipoteca_inversion.vue';
import step_datos_titular from '../components/new_steps/step_datos_titular.vue';
import step_datos_financieros from '../components/new_steps/step_datos_financieros.vue';
import step_datos_personales from '../components/new_steps/step_datos_personales.vue';
import step_aval_habitual from '../components/new_steps/step_aval_habitual.vue';
import step_aval_2avivienda from '../components/new_steps/step_aval_2avivienda.vue';
import step_aval_inversion from '../components/new_steps/step_aval_inversion.vue';

// Especiales
import ok_view_my from '../components/specialsViews/myInvestor_ok.vue';
import ok_view_helloteca from '../components/specialsViews/helloteca_ok.vue';
import aval_ko from '../components/specialsViews/aval_ko.vue';
import productos_helloteca from '../components/specialsViews/productos_helloteca.vue';


export default {
    name: 'MYMain',
    components: {       
        step_productos,
        step_datos_vivienda,
        step_datos_hipoteca_habitual,
        step_datos_hipoteca_mejora,
        step_datos_titular,
        step_datos_financieros,
        step_datos_personales,
        step_datos_hipoteca_2avivienda,
        step_datos_hipoteca_inversion,
        step_aval_habitual,
        step_aval_2avivienda,
        step_aval_inversion,
        ok_view_my,
        ok_view_helloteca,
        aval_ko,
        productos_helloteca
    },
    computed: {
        headerTitle() {
            return this.$store.state.headerTitle ;
        },
        headerSubtitle() {
            return this.$store.state.headerSubtitle ;
        },
        currentStepComponent() {
            return this.$store.state.currentStep;
        },
        // Vistas especiales
        specialStep() {
            return this.currentStepComponent == 'aval_ko' || this.currentStepComponent == 'ok_view_helloteca' || this.currentStepComponent == 'ok_view_my'|| this.currentStepComponent == 'productos_helloteca';
        }
    },
    methods: {
        updateHeaderTitle(newTitle) {
            this.$store.dispatch('setHeaderTitle', newTitle);
        },
        updateHeaderSubtitle(newSubtitle) {
            this.$store.dispatch('setHeaderSubtitle', newSubtitle);
        },

        // PARA CAMBIAR E TITULO Y SUBTITULO DESDE CUALQUIER COMPONENTE, PONER EN EL COMPONENTE
        // created() {
        //     this.$emit('update-title', 'Nuevo Título');
        //     this.$emit('update-subtitle', 'Nuevo Subtítulo');    
        // },
    }
}
</script>

<style>
    .main-container {
        min-height: calc(100vh - (var(--header-height) + var(--footer-height)));
    }
    .main_wrapper{  
        max-width: 1140px;   
        padding: 64px 30px; 
        margin: 0 auto; 
    }
    .main-section_header {
        margin-bottom: 40px;
    }
    .main-header_title{
        font-size: 56px;
        font-weight: var(--font-weight-bold);
        line-height: 72px;
        margin: 0 0 16px;
    }
    .main-header_text{
        font-size: var(--font-size-inputs);
        margin: 0;
    }
    .main-section_body{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    } 
    .main-form{
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        flex-shrink: 0;
    }
    .main-form_info > * {
        margin-bottom: 40px;
    }
    .main-form_info > *:last-child {
        margin-bottom: 0;
    }
    .main-image {
        width: 466px;
        height: 466px;
        background: url(../assets/casa_MY.png) rgb(255, 253, 253) 50% / cover no-repeat;
        display: block;
    } 
    /* MOVIL */
    @media (max-width: 768px) {
        .main_wrapper{
        }
        .main-section_header {
            margin-bottom: 32px;
        }
        .main-header_title{
            font-size: 32px;
            line-height: 40px;
        }
        .main-header_text{
            font-size: var(--font-size-inputs);
        }
        .main-image {
            display: none;
        }
    }
    /* TABLET */
    @media (min-width: 769px) and (max-width: 992px) {
        .main_wrapper{
            width: 90%;
        }
        .main-section_header {
            margin-bottom: 32px;
        }
        .main-header_title{
            font-size: 40px;
            line-height: 50px;
        }
        .main-header_text{
            font-size: var(--font-size-inputs);
        }
        .main-image {
            display: none;
        }
    }  
    /* ESCRITORIO*/
    @media (min-width: 993px) {
        .main-form{
            width: 50%;
        }
    }

</style>
